import { Box } from '@mui/material'
import { ProgressReportsOverview } from './ProgressReportsOverview'
import { Route, Routes } from 'react-router-dom'
import { OrgProgressReports } from './ProgressReports'

export const ProgressReportsTab = (): JSX.Element => {
  return (
    <Box>
      <Routes>
        <Route path="/" element={<ProgressReportsOverview />} />
        <Route path="/Organization/:orgId" element={<OrgProgressReports />} />
      </Routes>

    </Box>
  )
}
